// // // src/components/DriverDocumentUpload.js - MODIFIED to store files
// // import React, { useState } from 'react';
// // import {
// //   View,
// //   Text,
// //   TouchableOpacity,
// //   StyleSheet,
// //   ActivityIndicator,
// //   Alert,
// // } from 'react-native';
// // import * as ImagePicker from 'expo-image-picker';
// // import * as DocumentPicker from 'expo-document-picker';
// // import { useTranslation } from '../i18n';
// // import { useFileValidation } from '../hooks/useFileValidation';
// // import FileSizeErrorModal from './FileSizeErrorModal';

// // const COLORS = {
// //   primary: '#14B8A6',
// //   background: '#F7F9FA',
// //   card: '#FFFFFF',
// //   textDark: '#1C1C1E',
// //   textMuted: '#6B7280',
// //   error: '#DC2626',
// //   success: '#16A34A',
// //   border: '#E5E7EB',
// // };

// // const DOC_TYPES = {
// //   DRIVER_PHOTO: 'DRIVER_PHOTO',
// //   DRIVER_LICENSE: 'DRIVER_LICENSE',
// //   DRIVER_ID_CARD: 'DRIVER_ID_CARD',
// //   DRIVER_CAPACITY: 'DRIVER_CAPACITY',
// // };

// // const DriverDocumentUpload = ({
// //   docType,
// //   label,
// //   onFileSelected, // New callback to pass file to parent
// //   onSkip,
// //   disabled = false,
// // }) => {
// //   const { t } = useTranslation();
// //   const { validateFile, formatFileSize } = useFileValidation();
  
// //   const [uploading, setUploading] = useState(false);
// //   const [selectedFile, setSelectedFile] = useState(null);
// //   const [error, setError] = useState(null);
// //   const [skipped, setSkipped] = useState(false);
  
// //   // File error modal state
// //   const [showFileErrorModal, setShowFileErrorModal] = useState(false);
// //   const [invalidFile, setInvalidFile] = useState(null);
// //   const [fileErrorMessage, setFileErrorMessage] = useState('');

// //   const handleTakePhoto = async () => {
// //     try {
// //       setError(null);
      
// //       const { status } = await ImagePicker.requestCameraPermissionsAsync();
// //       if (status !== 'granted') {
// //         setError(t('documentUpload.cameraPermissionDenied'));
// //         return;
// //       }

// //       const result = await ImagePicker.launchCameraAsync({
// //         mediaTypes: ImagePicker.MediaTypeOptions.Images,
// //         quality: 0.7,
// //         allowsEditing: true,
// //       });

// //       if (!result.canceled && result.assets?.[0]) {
// //         const asset = result.assets[0];
// //         const fileInfo = {
// //           uri: asset.uri,
// //           name: asset.fileName || `${docType.toLowerCase()}_photo.jpg`,
// //           mimeType: 'image/jpeg',
// //           type: 'image/jpeg',
// //           size: asset.fileSize || 0,
// //         };
        
// //         await validateAndSetFile(fileInfo);
// //       }
// //     } catch (err) {
// //       console.error('Camera error: - DriverDocumentUpload.js:84', err);
// //       setError(t('common.error'));
// //     }
// //   };

// //   const handlePickDocument = async () => {
// //     try {
// //       setError(null);
      
// //       const result = await DocumentPicker.getDocumentAsync({
// //         type: ['application/pdf', 'image/*'],
// //         copyToCacheDirectory: true,
// //       });

// //       if (result.canceled) return;

// //       const asset = result.assets[0];
// //       const fileInfo = {
// //         uri: asset.uri,
// //         name: asset.name || `${docType.toLowerCase()}_doc`,
// //         mimeType: asset.mimeType || 'application/octet-stream',
// //         type: asset.mimeType || 'application/octet-stream',
// //         size: asset.size || 0,
// //       };

// //       await validateAndSetFile(fileInfo);
// //     } catch (err) {
// //       console.error('Document picker error: - DriverDocumentUpload.js:111', err);
// //       setError(t('documentUpload.selectionError'));
// //     }
// //   };

// //   const validateAndSetFile = async (fileInfo) => {
// //     // Validate file
// //     const validation = validateFile(fileInfo);
// //     if (!validation.isValid) {
// //       const error = validation.errors[0];
// //       setInvalidFile({
// //         name: fileInfo.name,
// //         size: fileInfo.size ? formatFileSize(fileInfo.size) : null
// //       });
// //       setFileErrorMessage(error.message);
// //       setShowFileErrorModal(true);
// //       return;
// //     }

// //     // Check file size again (15MB limit)
// //     if (fileInfo.size > 15 * 1024 * 1024) {
// //       setInvalidFile({
// //         name: fileInfo.name,
// //         size: formatFileSize(fileInfo.size)
// //       });
// //       setFileErrorMessage(t('fileValidation.fileTooLarge', { 
// //         maxSize: '15MB',
// //         fileName: fileInfo.name 
// //       }));
// //       setShowFileErrorModal(true);
// //       return;
// //     }

// //     setSelectedFile(fileInfo);
// //     setSkipped(false);
    
// //     // Pass the file to parent component
// //     if (onFileSelected) {
// //       onFileSelected(fileInfo);
// //     }
// //   };

// //   const handleSkip = () => {
// //     setSkipped(true);
// //     setSelectedFile(null);
// //     if (onSkip) {
// //       onSkip();
// //     }
// //   };

// //   const handleRemove = () => {
// //     setSelectedFile(null);
// //     setSkipped(false);
// //     if (onFileSelected) {
// //       onFileSelected(null); // Notify parent that file was removed
// //     }
// //   };

// //   const getDocumentTypeLabel = () => {
// //     switch (docType) {
// //       case DOC_TYPES.DRIVER_PHOTO:
// //         return t('driverManager.documents.photo');
// //       case DOC_TYPES.DRIVER_LICENSE:
// //         return t('driverManager.documents.license');
// //       case DOC_TYPES.DRIVER_ID_CARD:
// //         return t('driverManager.documents.idCard');
// //       case DOC_TYPES.DRIVER_CAPACITY:
// //         return t('driverManager.documents.capacity');
// //       default:
// //         return label || 'Document';
// //     }
// //   };

// //   return (
// //     <View style={styles.container}>
// //       <FileSizeErrorModal
// //         visible={showFileErrorModal}
// //         onDismiss={() => setShowFileErrorModal(false)}
// //         errorMessage={fileErrorMessage}
// //         fileName={invalidFile?.name}
// //         fileSize={invalidFile?.size}
// //         onRetry={() => {
// //           setShowFileErrorModal(false);
// //           setInvalidFile(null);
// //         }}
// //       />

// //       <Text style={styles.label}>
// //         {getDocumentTypeLabel()}
// //         <Text style={styles.optional}> ({t('common.optional')})</Text>
// //       </Text>

// //       {selectedFile ? (
// //         <View style={styles.uploadedContainer}>
// //           <View style={styles.uploadedInfo}>
// //             <Text style={styles.uploadedIcon}>✅</Text>
// //             <View style={styles.uploadedDetails}>
// //               <Text style={styles.uploadedName} numberOfLines={1}>
// //                 {selectedFile.name}
// //               </Text>
// //               {selectedFile.size > 0 && (
// //                 <Text style={styles.uploadedSize}>
// //                   {formatFileSize(selectedFile.size)}
// //                 </Text>
// //               )}
// //             </View>
// //           </View>
// //           <TouchableOpacity onPress={handleRemove} disabled={disabled}>
// //             <Text style={styles.removeText}>{t('common.remove')}</Text>
// //           </TouchableOpacity>
// //         </View>
// //       ) : skipped ? (
// //         <View style={styles.skippedContainer}>
// //           <Text style={styles.skippedText}>
// //             ⏭️ {t('driverManager.documents.skipped')}
// //           </Text>
// //           <TouchableOpacity onPress={() => setSkipped(false)} disabled={disabled}>
// //             <Text style={styles.undoText}>{t('common.undo')}</Text>
// //           </TouchableOpacity>
// //         </View>
// //       ) : (
// //         <View style={styles.uploadOptions}>
// //           <TouchableOpacity
// //             style={[styles.optionButton, disabled && styles.disabled]}
// //             onPress={handleTakePhoto}
// //             disabled={uploading || disabled}
// //           >
// //             {uploading ? (
// //               <ActivityIndicator size="small" color={COLORS.primary} />
// //             ) : (
// //               <>
// //                 <Text style={styles.optionIcon}>📸</Text>
// //                 <Text style={styles.optionText}>{t('documentUpload.takePhoto')}</Text>
// //               </>
// //             )}
// //           </TouchableOpacity>

// //           <TouchableOpacity
// //             style={[styles.optionButton, disabled && styles.disabled]}
// //             onPress={handlePickDocument}
// //             disabled={uploading || disabled}
// //           >
// //             <Text style={styles.optionIcon}>📁</Text>
// //             <Text style={styles.optionText}>{t('documentUpload.importFile')}</Text>
// //           </TouchableOpacity>

// //           <TouchableOpacity
// //             style={[styles.skipButton, disabled && styles.disabled]}
// //             onPress={handleSkip}
// //             disabled={uploading || disabled}
// //           >
// //             <Text style={styles.skipButtonText}>{t('common.skip')}</Text>
// //           </TouchableOpacity>
// //         </View>
// //       )}

// //       {error && <Text style={styles.errorText}>{error}</Text>}
// //     </View>
// //   );
// // };

// // const styles = StyleSheet.create({
// //   container: {
// //     marginBottom: 16,
// //     padding: 12,
// //     backgroundColor: COLORS.background,
// //     borderRadius: 8,
// //     borderWidth: 1,
// //     borderColor: COLORS.border,
// //   },
// //   label: {
// //     fontSize: 14,
// //     fontWeight: '600',
// //     color: COLORS.textDark,
// //     marginBottom: 8,
// //   },
// //   optional: {
// //     fontSize: 12,
// //     fontWeight: '400',
// //     color: COLORS.textMuted,
// //   },
// //   uploadOptions: {
// //     gap: 8,
// //   },
// //   optionButton: {
// //     flexDirection: 'row',
// //     alignItems: 'center',
// //     padding: 10,
// //     backgroundColor: COLORS.card,
// //     borderRadius: 8,
// //     borderWidth: 1,
// //     borderColor: COLORS.border,
// //     gap: 8,
// //   },
// //   optionIcon: {
// //     fontSize: 18,
// //   },
// //   optionText: {
// //     fontSize: 14,
// //     color: COLORS.textDark,
// //     fontWeight: '500',
// //   },
// //   skipButton: {
// //     padding: 8,
// //     alignItems: 'center',
// //   },
// //   skipButtonText: {
// //     fontSize: 14,
// //     color: COLORS.textMuted,
// //     fontWeight: '600',
// //   },
// //   uploadedContainer: {
// //     flexDirection: 'row',
// //     justifyContent: 'space-between',
// //     alignItems: 'center',
// //     padding: 10,
// //     backgroundColor: COLORS.success + '10',
// //     borderRadius: 8,
// //     borderWidth: 1,
// //     borderColor: COLORS.success,
// //   },
// //   uploadedInfo: {
// //     flexDirection: 'row',
// //     alignItems: 'center',
// //     flex: 1,
// //     gap: 8,
// //   },
// //   uploadedIcon: {
// //     fontSize: 18,
// //   },
// //   uploadedDetails: {
// //     flex: 1,
// //   },
// //   uploadedName: {
// //     fontSize: 14,
// //     fontWeight: '600',
// //     color: COLORS.textDark,
// //   },
// //   uploadedSize: {
// //     fontSize: 12,
// //     color: COLORS.textMuted,
// //     marginTop: 2,
// //   },
// //   removeText: {
// //     fontSize: 12,
// //     color: COLORS.error,
// //     fontWeight: '600',
// //   },
// //   skippedContainer: {
// //     flexDirection: 'row',
// //     justifyContent: 'space-between',
// //     alignItems: 'center',
// //     padding: 10,
// //     backgroundColor: COLORS.textMuted + '20',
// //     borderRadius: 8,
// //   },
// //   skippedText: {
// //     fontSize: 14,
// //     color: COLORS.textMuted,
// //     fontStyle: 'italic',
// //   },
// //   undoText: {
// //     fontSize: 12,
// //     color: COLORS.primary,
// //     fontWeight: '600',
// //   },
// //   errorText: {
// //     fontSize: 12,
// //     color: COLORS.error,
// //     marginTop: 4,
// //   },
// //   disabled: {
// //     opacity: 0.5,
// //   },
// // });

// // export default DriverDocumentUpload;

// // src/components/DriverDocumentUpload.js - UPDATED with conditional file types
// import React, { useState } from 'react';
// import {
//   View,
//   Text,
//   TouchableOpacity,
//   StyleSheet,
//   ActivityIndicator,
//   Alert,
// } from 'react-native';
// import * as ImagePicker from 'expo-image-picker';
// import * as DocumentPicker from 'expo-document-picker';
// import { useTranslation } from '../i18n';
// import { useFileValidation } from '../hooks/useFileValidation';
// import FileSizeErrorModal from './FileSizeErrorModal';

// const COLORS = {
//   primary: '#14B8A6',
//   background: '#F7F9FA',
//   card: '#FFFFFF',
//   textDark: '#1C1C1E',
//   textMuted: '#6B7280',
//   error: '#DC2626',
//   success: '#16A34A',
//   border: '#E5E7EB',
// };

// const DOC_TYPES = {
//   DRIVER_PHOTO: 'DRIVER_PHOTO',
//   DRIVER_LICENSE: 'DRIVER_LICENSE',
//   DRIVER_ID_CARD: 'DRIVER_ID_CARD',
//   DRIVER_CAPACITY: 'DRIVER_CAPACITY',
// };

// const DriverDocumentUpload = ({
//   docType,
//   label,
//   onFileSelected,
//   onSkip,
//   disabled = false,
// }) => {
//   const { t } = useTranslation();
//   const { validateFile, formatFileSize } = useFileValidation();
  
//   const [uploading, setUploading] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [error, setError] = useState(null);
//   const [skipped, setSkipped] = useState(false);
  
//   // File error modal state
//   const [showFileErrorModal, setShowFileErrorModal] = useState(false);
//   const [invalidFile, setInvalidFile] = useState(null);
//   const [fileErrorMessage, setFileErrorMessage] = useState('');

//   // Check if this document type should accept only images
//   const isPhotoOnly = docType === DOC_TYPES.DRIVER_PHOTO;

//   const handleTakePhoto = async () => {
//     try {
//       setError(null);
      
//       const { status } = await ImagePicker.requestCameraPermissionsAsync();
//       if (status !== 'granted') {
//         setError(t('documentUpload.cameraPermissionDenied'));
//         return;
//       }

//       const result = await ImagePicker.launchCameraAsync({
//         mediaTypes: ImagePicker.MediaTypeOptions.Images,
//         quality: 0.7,
//         allowsEditing: true,
//       });

//       if (!result.canceled && result.assets?.[0]) {
//         const asset = result.assets[0];
//         const fileInfo = {
//           uri: asset.uri,
//           name: asset.fileName || `${docType.toLowerCase()}_photo.jpg`,
//           mimeType: 'image/jpeg',
//           type: 'image/jpeg',
//           size: asset.fileSize || 0,
//         };
        
//         await validateAndSetFile(fileInfo);
//       }
//     } catch (err) {
//       console.error('Camera error: - DriverDocumentUpload.js:475', err);
//       setError(t('common.error'));
//     }
//   };

//   const handlePickDocument = async () => {
//     try {
//       setError(null);
      
//       // Set allowed file types based on document type
//       let allowedTypes = [];
      
//       if (isPhotoOnly) {
//         // For driver photo: only images
//         allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
//       } else {
//         // For other documents: PDF and images
//         allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
//       }

//       const result = await DocumentPicker.getDocumentAsync({
//         type: allowedTypes,
//         copyToCacheDirectory: true,
//       });

//       if (result.canceled) return;

//       const asset = result.assets[0];
      
//       // Validate mime type again (for extra safety)
//       const mimeType = asset.mimeType || 'application/octet-stream';
//       if (!allowedTypes.includes(mimeType) && !mimeType.startsWith('image/')) {
//         setFileErrorMessage(
//           isPhotoOnly 
//             ? t('fileValidation.onlyImagesAllowed', 'Seules les images sont autorisées pour la photo')
//             : t('fileValidation.pdfOrImagesAllowed', 'Seuls les PDF et images sont autorisés')
//         );
//         setInvalidFile({
//           name: asset.name,
//           size: asset.size ? formatFileSize(asset.size) : null
//         });
//         setShowFileErrorModal(true);
//         return;
//       }

//       const fileInfo = {
//         uri: asset.uri,
//         name: asset.name || `${docType.toLowerCase()}_doc`,
//         mimeType: mimeType,
//         type: mimeType,
//         size: asset.size || 0,
//       };

//       await validateAndSetFile(fileInfo);
//     } catch (err) {
//       console.error('Document picker error: - DriverDocumentUpload.js:530', err);
//       setError(t('documentUpload.selectionError'));
//     }
//   };

//   const validateAndSetFile = async (fileInfo) => {
//     // Validate file
//     const validation = validateFile(fileInfo);
//     if (!validation.isValid) {
//       const error = validation.errors[0];
//       setInvalidFile({
//         name: fileInfo.name,
//         size: fileInfo.size ? formatFileSize(fileInfo.size) : null
//       });
//       setFileErrorMessage(error.message);
//       setShowFileErrorModal(true);
//       return;
//     }

//     // Check file size again (15MB limit)
//     if (fileInfo.size > 15 * 1024 * 1024) {
//       setInvalidFile({
//         name: fileInfo.name,
//         size: formatFileSize(fileInfo.size)
//       });
//       setFileErrorMessage(t('fileValidation.fileTooLarge', { 
//         maxSize: '15MB',
//         fileName: fileInfo.name 
//       }));
//       setShowFileErrorModal(true);
//       return;
//     }

//     setSelectedFile(fileInfo);
//     setSkipped(false);
    
//     // Pass the file to parent component
//     if (onFileSelected) {
//       onFileSelected(fileInfo);
//     }
//   };

//   const handleSkip = () => {
//     setSkipped(true);
//     setSelectedFile(null);
//     if (onSkip) {
//       onSkip();
//     }
//   };

//   const handleRemove = () => {
//     setSelectedFile(null);
//     setSkipped(false);
//     if (onFileSelected) {
//       onFileSelected(null); // Notify parent that file was removed
//     }
//   };

//   const getDocumentTypeLabel = () => {
//     switch (docType) {
//       case DOC_TYPES.DRIVER_PHOTO:
//         return t('driverManager.documents.photo');
//       case DOC_TYPES.DRIVER_LICENSE:
//         return t('driverManager.documents.license');
//       case DOC_TYPES.DRIVER_ID_CARD:
//         return t('driverManager.documents.idCard');
//       case DOC_TYPES.DRIVER_CAPACITY:
//         return t('driverManager.documents.capacity');
//       default:
//         return label || 'Document';
//     }
//   };

//   const getAcceptedFormatsText = () => {
//     if (isPhotoOnly) {
//       return t('fileValidation.imageFormats', 'JPG, PNG');
//     }
//     return t('fileValidation.pdfImageFormats', 'PDF, JPG, PNG');
//   };

//   return (
//     <View style={styles.container}>
//       <FileSizeErrorModal
//         visible={showFileErrorModal}
//         onDismiss={() => setShowFileErrorModal(false)}
//         errorMessage={fileErrorMessage}
//         fileName={invalidFile?.name}
//         fileSize={invalidFile?.size}
//         onRetry={() => {
//           setShowFileErrorModal(false);
//           setInvalidFile(null);
//         }}
//       />

//       <Text style={styles.label}>
//         {getDocumentTypeLabel()}
//         <Text style={styles.optional}> ({t('common.optional')})</Text>
//       </Text>

//       {/* Show accepted formats hint */}
//       <Text style={styles.formatHint}>
//         {t('fileValidation.acceptedFormats', 'Formats acceptés')}: {getAcceptedFormatsText()} (Max 15MB)
//       </Text>

//       {selectedFile ? (
//         <View style={styles.uploadedContainer}>
//           <View style={styles.uploadedInfo}>
//             <Text style={styles.uploadedIcon}>✅</Text>
//             <View style={styles.uploadedDetails}>
//               <Text style={styles.uploadedName} numberOfLines={1}>
//                 {selectedFile.name}
//               </Text>
//               {selectedFile.size > 0 && (
//                 <Text style={styles.uploadedSize}>
//                   {formatFileSize(selectedFile.size)}
//                 </Text>
//               )}
//             </View>
//           </View>
//           <TouchableOpacity onPress={handleRemove} disabled={disabled}>
//             <Text style={styles.removeText}>{t('common.remove')}</Text>
//           </TouchableOpacity>
//         </View>
//       ) : skipped ? (
//         <View style={styles.skippedContainer}>
//           <Text style={styles.skippedText}>
//             ⏭️ {t('driverManager.documents.skipped')}
//           </Text>
//           <TouchableOpacity onPress={() => setSkipped(false)} disabled={disabled}>
//             <Text style={styles.undoText}>{t('common.undo')}</Text>
//           </TouchableOpacity>
//         </View>
//       ) : (
//         <View style={styles.uploadOptions}>
//           <TouchableOpacity
//             style={[styles.optionButton, disabled && styles.disabled]}
//             onPress={handleTakePhoto}
//             disabled={uploading || disabled}
//           >
//             {uploading ? (
//               <ActivityIndicator size="small" color={COLORS.primary} />
//             ) : (
//               <>
//                 <Text style={styles.optionIcon}>📸</Text>
//                 <Text style={styles.optionText}>{t('documentUpload.takePhoto')}</Text>
//               </>
//             )}
//           </TouchableOpacity>

//           <TouchableOpacity
//             style={[styles.optionButton, disabled && styles.disabled]}
//             onPress={handlePickDocument}
//             disabled={uploading || disabled}
//           >
//             <Text style={styles.optionIcon}>📁</Text>
//             <Text style={styles.optionText}>
//               {isPhotoOnly 
//                 ? t('documentUpload.importImage', 'Importer une image')
//                 : t('documentUpload.importFile', 'Importer un fichier')}
//             </Text>
//           </TouchableOpacity>

//           <TouchableOpacity
//             style={[styles.skipButton, disabled && styles.disabled]}
//             onPress={handleSkip}
//             disabled={uploading || disabled}
//           >
//             <Text style={styles.skipButtonText}>{t('common.skip')}</Text>
//           </TouchableOpacity>
//         </View>
//       )}

//       {error && <Text style={styles.errorText}>{error}</Text>}
//     </View>
//   );
// };

// const styles = StyleSheet.create({
//   container: {
//     marginBottom: 16,
//     padding: 12,
//     backgroundColor: COLORS.background,
//     borderRadius: 8,
//     borderWidth: 1,
//     borderColor: COLORS.border,
//   },
//   label: {
//     fontSize: 14,
//     fontWeight: '600',
//     color: COLORS.textDark,
//     marginBottom: 4,
//   },
//   optional: {
//     fontSize: 12,
//     fontWeight: '400',
//     color: COLORS.textMuted,
//   },
//   formatHint: {
//     fontSize: 11,
//     color: COLORS.textMuted,
//     marginBottom: 8,
//     fontStyle: 'italic',
//   },
//   uploadOptions: {
//     gap: 8,
//   },
//   optionButton: {
//     flexDirection: 'row',
//     alignItems: 'center',
//     padding: 10,
//     backgroundColor: COLORS.card,
//     borderRadius: 8,
//     borderWidth: 1,
//     borderColor: COLORS.border,
//     gap: 8,
//   },
//   optionIcon: {
//     fontSize: 18,
//   },
//   optionText: {
//     fontSize: 14,
//     color: COLORS.textDark,
//     fontWeight: '500',
//   },
//   skipButton: {
//     padding: 8,
//     alignItems: 'center',
//   },
//   skipButtonText: {
//     fontSize: 14,
//     color: COLORS.textMuted,
//     fontWeight: '600',
//   },
//   uploadedContainer: {
//     flexDirection: 'row',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: 10,
//     backgroundColor: COLORS.success + '10',
//     borderRadius: 8,
//     borderWidth: 1,
//     borderColor: COLORS.success,
//   },
//   uploadedInfo: {
//     flexDirection: 'row',
//     alignItems: 'center',
//     flex: 1,
//     gap: 8,
//   },
//   uploadedIcon: {
//     fontSize: 18,
//   },
//   uploadedDetails: {
//     flex: 1,
//   },
//   uploadedName: {
//     fontSize: 14,
//     fontWeight: '600',
//     color: COLORS.textDark,
//   },
//   uploadedSize: {
//     fontSize: 12,
//     color: COLORS.textMuted,
//     marginTop: 2,
//   },
//   removeText: {
//     fontSize: 12,
//     color: COLORS.error,
//     fontWeight: '600',
//   },
//   skippedContainer: {
//     flexDirection: 'row',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: 10,
//     backgroundColor: COLORS.textMuted + '20',
//     borderRadius: 8,
//   },
//   skippedText: {
//     fontSize: 14,
//     color: COLORS.textMuted,
//     fontStyle: 'italic',
//   },
//   undoText: {
//     fontSize: 12,
//     color: COLORS.primary,
//     fontWeight: '600',
//   },
//   errorText: {
//     fontSize: 12,
//     color: COLORS.error,
//     marginTop: 4,
//   },
//   disabled: {
//     opacity: 0.5,
//   },
// });

// export default DriverDocumentUpload;


import React, { useEffect, useMemo, useState } from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
} from 'react-native';
import * as ImagePicker from 'expo-image-picker';
import * as DocumentPicker from 'expo-document-picker';
import { useTranslation } from '../i18n';
import { useFileValidation } from '../hooks/useFileValidation';
import FileSizeErrorModal from './FileSizeErrorModal';

const COLORS = {
  primary: '#14B8A6',
  background: '#F7F9FA',
  card: '#FFFFFF',
  textDark: '#1C1C1E',
  textMuted: '#6B7280',
  error: '#DC2626',
  success: '#16A34A',
  warning: '#F59E0B',
  border: '#E5E7EB',
};

const EMPTY_VALUE = {
  front: null,
  back: null,
  pdf: null,
  skipped: false,
};

const DOC_LABELS = {
  DRIVER_PHOTO: 'Photo d’identité',
  DRIVER_LICENSE: 'Permis de conduire catégorie B',
  DRIVER_ID_CARD: "Carte Nationale d'Identité",
  DRIVER_CAPACITY: 'Certificat de capacité modèle T',
  DRIVER_RESIDENCE_CARD: 'Carte de résidence',
  DRIVER_PROFESSIONAL_BADGE: "Badge professionnel d'identification",
};

function normalizeValue(value) {
  if (!value) return { ...EMPTY_VALUE };

  if (
    Object.prototype.hasOwnProperty.call(value, 'front') ||
    Object.prototype.hasOwnProperty.call(value, 'back') ||
    Object.prototype.hasOwnProperty.call(value, 'pdf') ||
    Object.prototype.hasOwnProperty.call(value, 'skipped')
  ) {
    return {
      front: value.front || null,
      back: value.back || null,
      pdf: value.pdf || null,
      skipped: Boolean(value.skipped),
    };
  }

  // Backward compatibility for old single-file value
  if (value.uri || value.name || value.mimeType || value.type) {
    return {
      front: value,
      back: null,
      pdf: null,
      skipped: false,
    };
  }

  return { ...EMPTY_VALUE };
}

function isPdf(file) {
  const type = String(file?.mimeType || file?.type || '').toLowerCase();
  const name = String(file?.name || '').toLowerCase();

  return type === 'application/pdf' || name.endsWith('.pdf');
}

function fileLabel(file) {
  if (!file) return '';
  return file.name || file.fileName || 'document';
}

function isPickerCanceled(result) {
  return (
    result?.canceled === true ||
    result?.cancelled === true ||
    result?.type === 'cancel'
  );
}

function getFirstPickerAsset(result) {
  if (result?.assets?.[0]) return result.assets[0];

  // Older Expo DocumentPicker shape
  if (result?.uri) {
    return {
      uri: result.uri,
      name: result.name,
      mimeType: result.mimeType || result.type,
      size: result.size,
      fileSize: result.fileSize,
    };
  }

  return null;
}

export function hasCompleteTwoSidedDocument(value, options = {}) {
  const { photoOnly = false } = options;
  const v = normalizeValue(value);

  if (v.skipped) return true;

  if (photoOnly) {
    return Boolean(v.front);
  }

  if (v.pdf) return true;

  return Boolean(v.front && v.back);
}

const DriverDocumentUpload = ({
  docType,
  label,
  value,
  onFileSelected,
  onSkip,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const { validateFile, formatFileSize } = useFileValidation();

  const isPhotoOnly = docType === 'DRIVER_PHOTO';

  const [docValue, setDocValue] = useState(() => normalizeValue(value));
  const [error, setError] = useState(null);

  const [showFileErrorModal, setShowFileErrorModal] = useState(false);
  const [invalidFile, setInvalidFile] = useState(null);
  const [fileErrorMessage, setFileErrorMessage] = useState('');

  useEffect(() => {
    setDocValue(normalizeValue(value));
  }, [value]);

  const title = useMemo(() => {
    return label || DOC_LABELS[docType] || 'Document';
  }, [label, docType]);

  const complete = hasCompleteTwoSidedDocument(docValue, {
    photoOnly: isPhotoOnly,
  });

  function emit(nextValue) {
    const normalized = normalizeValue(nextValue);
    setDocValue(normalized);

    if (onFileSelected) {
      onFileSelected(normalized);
    }
  }

  function validatePickedFile(fileInfo) {
    const validation = validateFile(fileInfo);

    if (!validation.isValid) {
      const firstError = validation.errors[0];

      setInvalidFile({
        name: fileInfo.name,
        size: fileInfo.size ? formatFileSize(fileInfo.size) : null,
      });

      setFileErrorMessage(firstError.message);
      setShowFileErrorModal(true);

      return false;
    }

    if (fileInfo.size > 15 * 1024 * 1024) {
      setInvalidFile({
        name: fileInfo.name,
        size: formatFileSize(fileInfo.size),
      });

      setFileErrorMessage(
        t('fileValidation.fileTooLarge', {
          maxSize: '15MB',
          fileName: fileInfo.name,
        })
      );

      setShowFileErrorModal(true);

      return false;
    }

    return true;
  }

  function buildImageFile(asset, side = 'front') {
    return {
      uri: asset.uri,
      name:
        asset.fileName ||
        asset.name ||
        `${String(docType || 'document').toLowerCase()}_${side}.jpg`,
      mimeType: 'image/jpeg',
      type: 'image/jpeg',
      size: asset.fileSize || asset.size || 0,
    };
  }

  function buildPickedFile(asset) {
    return {
      uri: asset.uri,
      name: asset.name || `${String(docType || 'document').toLowerCase()}_file`,
      mimeType: asset.mimeType || asset.type || 'application/octet-stream',
      type: asset.mimeType || asset.type || 'application/octet-stream',
      size: asset.size || asset.fileSize || 0,
    };
  }

  async function takePhoto(side = 'front') {
    if (disabled) return;

    try {
      setError(null);

      const { status } = await ImagePicker.requestCameraPermissionsAsync();

      if (status !== 'granted') {
        setError(t('documentUpload.cameraPermissionDenied'));
        return;
      }

      const result = await ImagePicker.launchCameraAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        quality: 0.7,
        allowsEditing: true,
      });

      if (isPickerCanceled(result)) {
        return;
      }

      const asset = getFirstPickerAsset(result);

      if (!asset) {
        return;
      }

      const fileInfo = buildImageFile(asset, side);

      if (!validatePickedFile(fileInfo)) {
        return;
      }

      if (isPhotoOnly) {
        emit({
          front: fileInfo,
          back: null,
          pdf: null,
          skipped: false,
        });

        return;
      }

      emit({
        ...docValue,
        [side]: fileInfo,
        pdf: null,
        skipped: false,
      });
    } catch (err) {
      console.error('Driver document camera error:', err);
      setError(t('common.error'));
    }
  }

  async function pickImage(side = 'front') {
    if (disabled) return;

    try {
      setError(null);

      const result = await DocumentPicker.getDocumentAsync({
        type: ['image/jpeg', 'image/jpg', 'image/png', 'image/*'],
        copyToCacheDirectory: true,
      });

      if (isPickerCanceled(result)) {
        return;
      }

      const asset = getFirstPickerAsset(result);

      if (!asset) {
        return;
      }

      const fileInfo = buildPickedFile(asset);

      const mimeType = String(
        fileInfo.mimeType || fileInfo.type || ''
      ).toLowerCase();

      if (!mimeType.startsWith('image/')) {
        setInvalidFile({
          name: fileInfo.name,
          size: fileInfo.size ? formatFileSize(fileInfo.size) : null,
        });

        setFileErrorMessage('Veuillez choisir une image.');
        setShowFileErrorModal(true);
        return;
      }

      if (!validatePickedFile(fileInfo)) {
        return;
      }

      if (isPhotoOnly) {
        emit({
          front: fileInfo,
          back: null,
          pdf: null,
          skipped: false,
        });

        return;
      }

      emit({
        ...docValue,
        [side]: fileInfo,
        pdf: null,
        skipped: false,
      });
    } catch (err) {
      console.error('Driver document image picker error:', err);
      setError(t('documentUpload.selectionError'));
    }
  }

  async function pickPdf() {
    if (disabled) return;

    try {
      setError(null);

      const result = await DocumentPicker.getDocumentAsync({
        type: ['application/pdf'],
        copyToCacheDirectory: true,
      });

      if (isPickerCanceled(result)) {
        return;
      }

      const asset = getFirstPickerAsset(result);

      if (!asset) {
        return;
      }

      const fileInfo = buildPickedFile(asset);

      if (!isPdf(fileInfo)) {
        setInvalidFile({
          name: fileInfo.name,
          size: fileInfo.size ? formatFileSize(fileInfo.size) : null,
        });

        setFileErrorMessage('Veuillez choisir un fichier PDF.');
        setShowFileErrorModal(true);
        return;
      }

      if (!validatePickedFile(fileInfo)) {
        return;
      }

      emit({
        front: null,
        back: null,
        pdf: fileInfo,
        skipped: false,
      });
    } catch (err) {
      console.error('Driver document PDF picker error:', err);
      setError(t('documentUpload.selectionError'));
    }
  }

  function removePart(part) {
    emit({
      ...docValue,
      [part]: null,
      skipped: false,
    });
  }

  function skipDocument() {
    const nextValue = {
      front: null,
      back: null,
      pdf: null,
      skipped: true,
    };

    setDocValue(nextValue);

    if (onFileSelected) {
      onFileSelected(nextValue);
    }

    if (onSkip) {
      onSkip(nextValue);
    }
  }

  function undoSkip() {
    emit({ ...EMPTY_VALUE });
  }

  function FileChip({ label: chipLabel, file, part }) {
    if (!file) return null;

    return (
      <View style={styles.fileChip}>
        <View style={{ flex: 1 }}>
          <Text style={styles.fileChipLabel}>{chipLabel}</Text>

          <Text style={styles.fileName} numberOfLines={1}>
            {fileLabel(file)}
          </Text>

          {file.size > 0 && (
            <Text style={styles.fileSize}>{formatFileSize(file.size)}</Text>
          )}
        </View>

        {!disabled && (
          <TouchableOpacity onPress={() => removePart(part)}>
            <Text style={styles.removeText}>{t('common.remove')}</Text>
          </TouchableOpacity>
        )}
      </View>
    );
  }

  function shouldShowButton(type) {
    if (isPhotoOnly) {
      return !docValue.front;
    }

    switch (type) {
      case 'front':
        return !docValue.front && !docValue.pdf;

      case 'back':
        return Boolean(docValue.front) && !docValue.back && !docValue.pdf;

      case 'pdf':
        return !docValue.pdf && !docValue.front && !docValue.back;

      default:
        return true;
    }
  }

  return (
    <View
      style={[
        styles.container,
        complete && !docValue.skipped && styles.containerComplete,
        docValue.skipped && styles.containerSkipped,
      ]}
    >
      <FileSizeErrorModal
        visible={showFileErrorModal}
        onDismiss={() => setShowFileErrorModal(false)}
        errorMessage={fileErrorMessage}
        fileName={invalidFile?.name}
        fileSize={invalidFile?.size}
        onRetry={() => {
          setShowFileErrorModal(false);
          setInvalidFile(null);
        }}
      />

      <View style={styles.header}>
        <View style={{ flex: 1 }}>
          <Text style={styles.label}>
            {title}
            <Text style={styles.optional}> ({t('common.optional')})</Text>
          </Text>

          <Text style={styles.formatHint}>
            {isPhotoOnly
              ? 'Image obligatoire pour la photo.'
              : 'Images: recto + verso requis. PDF: document complet accepté.'}
          </Text>
        </View>

        {complete && !docValue.skipped && (
          <Text style={styles.completeBadge}>Complet</Text>
        )}

        {docValue.skipped && (
          <Text style={styles.skippedBadge}>Ignoré</Text>
        )}
      </View>

      {docValue.skipped ? (
        <View style={styles.skippedContainer}>
          <Text style={styles.skippedText}>
            ⏭️ {t('driverManager.documents.skipped')}
          </Text>

          {!disabled && (
            <TouchableOpacity onPress={undoSkip}>
              <Text style={styles.undoText}>{t('common.undo')}</Text>
            </TouchableOpacity>
          )}
        </View>
      ) : (
        <>
          <FileChip
            label={isPhotoOnly ? 'Photo' : 'Recto'}
            file={docValue.front}
            part="front"
          />

          {!isPhotoOnly && (
            <>
              <FileChip label="Verso" file={docValue.back} part="back" />
              <FileChip label="PDF complet" file={docValue.pdf} part="pdf" />
            </>
          )}

          <View style={styles.uploadOptions}>
            {isPhotoOnly ? (
              <>
                {shouldShowButton('front') && (
                  <>
                    <TouchableOpacity
                      style={[
                        styles.optionButton,
                        disabled && styles.disabled,
                      ]}
                      onPress={() => takePhoto('front')}
                      disabled={disabled}
                    >
                      <Text style={styles.optionIcon}>📸</Text>
                      <Text style={styles.optionText}>Prendre la photo</Text>
                    </TouchableOpacity>

                    <TouchableOpacity
                      style={[
                        styles.optionButton,
                        disabled && styles.disabled,
                      ]}
                      onPress={() => pickImage('front')}
                      disabled={disabled}
                    >
                      <Text style={styles.optionIcon}>📁</Text>
                      <Text style={styles.optionText}>Importer une image</Text>
                    </TouchableOpacity>
                  </>
                )}
              </>
            ) : (
              <>
                {shouldShowButton('front') && (
                  <>
                    <TouchableOpacity
                      style={[
                        styles.optionButton,
                        disabled && styles.disabled,
                      ]}
                      onPress={() => takePhoto('front')}
                      disabled={disabled}
                    >
                      <Text style={styles.optionIcon}>📸</Text>
                      <Text style={styles.optionText}>Prendre recto</Text>
                    </TouchableOpacity>

                    <TouchableOpacity
                      style={[
                        styles.optionButton,
                        disabled && styles.disabled,
                      ]}
                      onPress={() => pickImage('front')}
                      disabled={disabled}
                    >
                      <Text style={styles.optionIcon}>🖼️</Text>
                      <Text style={styles.optionText}>Importer recto</Text>
                    </TouchableOpacity>
                  </>
                )}

                {shouldShowButton('back') && (
                  <>
                    <TouchableOpacity
                      style={[
                        styles.optionButton,
                        disabled && styles.disabled,
                      ]}
                      onPress={() => takePhoto('back')}
                      disabled={disabled}
                    >
                      <Text style={styles.optionIcon}>📸</Text>
                      <Text style={styles.optionText}>Prendre verso</Text>
                    </TouchableOpacity>

                    <TouchableOpacity
                      style={[
                        styles.optionButton,
                        disabled && styles.disabled,
                      ]}
                      onPress={() => pickImage('back')}
                      disabled={disabled}
                    >
                      <Text style={styles.optionIcon}>🖼️</Text>
                      <Text style={styles.optionText}>Importer verso</Text>
                    </TouchableOpacity>
                  </>
                )}

                {shouldShowButton('pdf') && (
                  <TouchableOpacity
                    style={[
                      styles.optionButton,
                      disabled && styles.disabled,
                    ]}
                    onPress={pickPdf}
                    disabled={disabled}
                  >
                    <Text style={styles.optionIcon}>📄</Text>
                    <Text style={styles.optionText}>Importer PDF complet</Text>
                  </TouchableOpacity>
                )}
              </>
            )}

            <TouchableOpacity
              style={[
                styles.skipButton,
                disabled && styles.disabled,
              ]}
              onPress={skipDocument}
              disabled={disabled}
            >
              <Text style={styles.skipButtonText}>{t('common.skip')}</Text>
            </TouchableOpacity>
          </View>
        </>
      )}

      {error && <Text style={styles.errorText}>{error}</Text>}

      {!docValue.skipped && !complete && (
        <Text style={styles.requiredHint}>
          {isPhotoOnly
            ? 'Veuillez ajouter la photo ou ignorer ce document.'
            : 'Veuillez ajouter le recto et le verso, ou importer un PDF complet.'}
        </Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 16,
    padding: 12,
    backgroundColor: COLORS.background,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: COLORS.border,
  },

  containerComplete: {
    borderColor: COLORS.success,
    backgroundColor: '#F0FDF4',
  },

  containerSkipped: {
    borderColor: COLORS.warning,
    backgroundColor: '#FFFBEB',
  },

  header: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 8,
    marginBottom: 8,
  },

  label: {
    fontSize: 14,
    fontWeight: '700',
    color: COLORS.textDark,
    marginBottom: 4,
  },

  optional: {
    fontSize: 12,
    fontWeight: '400',
    color: COLORS.textMuted,
  },

  formatHint: {
    fontSize: 11,
    color: COLORS.textMuted,
    fontStyle: 'italic',
  },

  completeBadge: {
    fontSize: 11,
    fontWeight: '800',
    color: COLORS.success,
    backgroundColor: '#DCFCE7',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 999,
  },

  skippedBadge: {
    fontSize: 11,
    fontWeight: '800',
    color: '#92400E',
    backgroundColor: '#FEF3C7',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 999,
  },

  uploadOptions: {
    gap: 8,
  },

  optionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 10,
    backgroundColor: COLORS.card,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: COLORS.border,
    gap: 8,
  },

  optionIcon: {
    fontSize: 18,
  },

  optionText: {
    fontSize: 14,
    color: COLORS.textDark,
    fontWeight: '600',
  },

  skipButton: {
    padding: 8,
    alignItems: 'center',
  },

  skipButtonText: {
    fontSize: 14,
    color: COLORS.textMuted,
    fontWeight: '700',
  },

  fileChip: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 10,
    backgroundColor: COLORS.card,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: COLORS.success,
    marginBottom: 8,
    gap: 10,
  },

  fileChipLabel: {
    fontSize: 11,
    fontWeight: '800',
    color: COLORS.success,
    textTransform: 'uppercase',
    marginBottom: 2,
  },

  fileName: {
    fontSize: 14,
    fontWeight: '600',
    color: COLORS.textDark,
  },

  fileSize: {
    fontSize: 12,
    color: COLORS.textMuted,
    marginTop: 2,
  },

  removeText: {
    fontSize: 12,
    color: COLORS.error,
    fontWeight: '700',
  },

  skippedContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 10,
    backgroundColor: '#FEF3C7',
    borderRadius: 8,
  },

  skippedText: {
    fontSize: 14,
    color: '#92400E',
    fontStyle: 'italic',
  },

  undoText: {
    fontSize: 12,
    color: COLORS.primary,
    fontWeight: '700',
  },

  errorText: {
    fontSize: 12,
    color: COLORS.error,
    marginTop: 6,
  },

  requiredHint: {
    fontSize: 12,
    color: COLORS.warning,
    marginTop: 8,
    fontWeight: '600',
  },

  disabled: {
    opacity: 0.5,
  },
});

export default DriverDocumentUpload;